import { configureStore } from '@reduxjs/toolkit';
import { adfoxPuidsReducer, adfoxPuidsReducerName } from 'shared/slices/adfox';
import { commercialLinkReducerName, commercialLinkReducer } from 'shared/slices/commercialLink';
import { experimentsReducer, experimentsReducerName } from 'shared/slices/experiments';
import { geoReducer, geoReducerName } from 'shared/slices/geo';
import {
  isInlineFiltersRedesignedReducer,
  isInlineFiltersRedesignedReducerName,
} from 'shared/slices/isInlineFiltersRedesigned';
import { jsonQueryReducerName, jsonQueryReducer } from 'shared/slices/jsonQuery';
import { locationReducer, locationReducerName } from 'shared/slices/location';
import { pageReducer, pageReducerName } from 'shared/slices/page';
import { promoSearchTypesReducer, promoSearchTypesReducerName } from 'shared/slices/promoSearchTypes';
import { regionsReducer, regionsReducerName } from 'shared/slices/regions';
import { searchMetaReducer, searchMetaReducerName } from 'shared/slices/searchMeta';
import { searchMetaTooltipReducer, searchMetaTooltipReducerName } from 'shared/slices/searchMetaTooltip';
import { specialPromosReducerName, specialPromosReducer } from 'shared/slices/specialPromos';
import { specialtyTypeOptionsReducer, specialtyTypeOptionsReducerName } from 'shared/slices/specialtyTypeOptions';
import {
  businessAppointmentOptionsReducer,
  businessAppointmentOptionsReducerName,
} from 'shared/slices/businessAppointmentOptions';
import { tagsReducer, tagsReducerName } from 'shared/slices/tags';
import { modalsReducer, modalsReducerName } from 'shared/slices/modal';

import { IApplicationContext } from 'shared/types/applicationContext';
import { IPreloadedState } from 'shared/types/redux';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(context: IApplicationContext, preloadedState: IPreloadedState, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: /* istanbul ignore next */ getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      [modalsReducerName]: modalsReducer,
      [jsonQueryReducerName]: jsonQueryReducer,
      [locationReducerName]: locationReducer,
      [searchMetaReducerName]: searchMetaReducer,
      [tagsReducerName]: tagsReducer,
      [regionsReducerName]: regionsReducer,
      [geoReducerName]: geoReducer,
      [pageReducerName]: pageReducer,
      [promoSearchTypesReducerName]: promoSearchTypesReducer,
      [experimentsReducerName]: experimentsReducer,
      [searchMetaTooltipReducerName]: searchMetaTooltipReducer,
      [adfoxPuidsReducerName]: adfoxPuidsReducer,
      [commercialLinkReducerName]: commercialLinkReducer,
      [specialPromosReducerName]: specialPromosReducer,
      [specialtyTypeOptionsReducerName]: specialtyTypeOptionsReducer,
      [businessAppointmentOptionsReducerName]: businessAppointmentOptionsReducer,
      [isInlineFiltersRedesignedReducerName]: isInlineFiltersRedesignedReducer,
    },
  });
}
